import { i18n as i18nType } from 'i18next'

import accountSettings, { AccountSettingsKeys } from './accountSettings'
import accountHome, { AccountHomeKeys } from './accountHome'
import authRepGenerator, { AuthRepKeys } from './authRep'
import claims, { ClaimsKeys } from './claims'
import mcf, { MCFKeys } from './mcf'
import preventiveServices, {
  preventiveServicesKeys
} from './preventiveServices'

export type {
  EventMapGenerator,
  GenericEventMap,
  SiteActivityConfig
} from './baseGenerator'

export interface GeneratorArgs {
  i18n: i18nType
}

export type LinkClickFireEvent = ({ linkUrl }: { linkUrl: string }) => void

export type FullEventMapKeys =
  | AccountSettingsKeys
  | AuthRepKeys
  | ClaimsKeys
  | MCFKeys
  | preventiveServicesKeys
  | AccountHomeKeys

export type SpecificEventMap = ReturnType<typeof generateEventMap>

export const generateEventMap = ({ i18n }: GeneratorArgs) => {
  return {
    accountSettings: accountSettings({ i18n }),
    accountHome: accountHome({ i18n }),
    authRep: authRepGenerator({ i18n }),
    claims: claims({ i18n }),
    mcf: mcf({ i18n }),
    preventiveServices: preventiveServices({ i18n })
  }
}

export default generateEventMap
